import { v4 as uuidv4 } from 'uuid';
import { AuthWrapperService } from '../services/AuthWrapper.service';
import { Injectable } from '@angular/core';
import { IntegrationService } from '../services/integration.service';

@Injectable({ providedIn: 'root' })
export class HeadersService {
  constructor(private readonly authService: AuthWrapperService, private integrationService: IntegrationService) { }

  public createHeadersWithJsonApiContentSharedToken(
    resourceVersion?: string,
    correlationId?: string
  ): { [name: string]: string } {
    return {
      Authorization: 'Bearer ' + this.authService.getToken(),
      'Schwab-Client-CorrelId': correlationId ? correlationId : uuidv4(),
      'Schwab-Env': this.integrationService.JfkEnv.EnvironmentHeader,
      'Schwab-RRBus-PilotRollout': this.integrationService.JfkEnv.EnvironmentHeader,
      'Schwab-Client-Env': this.integrationService.JfkEnv.EnvironmentHeader,
      'Schwab-Client-Channel': this.integrationService.JfkEnv.ChannelCode,
      'Schwab-Resource-Version': resourceVersion ? resourceVersion : '1',
      // 'Schwab-Client-Account': this.globalVar.accountID,
      'Schwab-Client-FirmId': this.integrationService.currentContext.firmId.toString(),
      'Schwab-Client-AppId': 'AD00007177',
      'Content-Type': 'application/vnd.api+json',
      'Money-Movement-Ui-Origin': '1'
    };
  }
  public createHeadersNotJsonApi(
    resourceVersion?: string,
    correlationId?: string
  ): { [name: string]: string } {
    let headers = {
      Authorization: 'Bearer ' + this.authService.getToken(),
      'Schwab-Client-CorrelId': correlationId ? correlationId : uuidv4(),
      'Schwab-Env': this.integrationService.JfkEnv.EnvironmentHeader,
      'Schwab-RRBus-PilotRollout': this.integrationService.JfkEnv.EnvironmentHeader,
      'Schwab-Client-Env': this.integrationService.JfkEnv.EnvironmentHeader,
      'Schwab-Client-Channel': this.integrationService.JfkEnv.ChannelCode,
      'Schwab-Resource-Version': resourceVersion ? resourceVersion : '1',
      // 'Schwab-Client-Account': this.globalVar.accountID,
      'Schwab-Client-FirmId': this.integrationService.currentContext.firmId.toString(),
      'Schwab-Client-AppId': 'AD00007177',
      'Content-Type': 'application/json-patch+json',
      'Money-Movement-Ui-Origin': '1'
    };
    return headers;
  }
}
